import Vue from 'vue'

// 避免多次点击弹出多个弹框，同一个弹框一定时间内只弹一次，不同弹框可覆盖
export default {
  open(message, type, duration) {
    if (this.messageContent === message) {
      if (this.messageIsClose) {
        return
      }
    } else {
      this.messageIsClose = false
      this.messageContent = message
    }
    if (!this.messageIsClose) {
      this.messageIsClose = true
      Vue.prototype.$$message({
        message,
        duration: duration || 1500,
        type,
        onClose: val => {
          console.log(val)
          this.messageIsClose = false
        }
      })
    }
  },
  error(message, duration) {
    this.open(message, 'error', duration)
  },
  success(message, duration) {
    this.open(message, 'success', duration)
  }
}
